import G from "@sd-utility/debounce";
import y from "classnames";
import n from "no-scroll";
import r, { forwardRef as J, useState as b, useRef as K, useCallback as k, useEffect as I } from "react";
import { Button as L } from "../button/basic-button.esm.js";
import { StickyDrawer as M } from "../sticky-drawer/sticky-drawer.esm.js";
import { useNamedId as Q } from "../utils/hooks/useId.esm.js";
import { s, D as U } from "../drawer-header-BHBOBwu7.mjs";
const V = {
  right: "right"
}, W = J(
  ({
    className: p,
    backCallback: D = () => {
    },
    children: c,
    closeCallback: g = () => {
    },
    dataTestId: h,
    hasBackButton: N = !1,
    promotionalArea: f,
    onClose: v = () => {
    },
    open: e = !1,
    stickyDrawer: m = {
      container: {
        className: "fuse-drawer__sticky-drawer",
        dataTestId: "fuse-drawer-sticky-drawer-data-testid",
        open: !1,
        transition: void 0,
        zIndex: void 0
      },
      button: /* @__PURE__ */ r.createElement(L, null)
    },
    slidePosition: E = V.right,
    srLabelBackButton: S,
    srLabelCloseButton: x,
    title: T,
    zIndex: $,
    desktopDisplay: z = !0,
    style: C,
    ...H
  }, l) => {
    var w, _;
    const [B, F] = b(!1), [i, d] = b(!1), o = K(null), u = Q("fuse-drawer-header"), { container: a } = m, O = a.open ? (_ = (w = o == null ? void 0 : o.current) == null ? void 0 : w.children[2]) == null ? void 0 : _.offsetHeight : 0, R = k(
      (t) => G(
        (j) => {
          const { scrollTop: q } = j, A = q > 0;
          F(A);
        },
        20,
        !1
      )(t.currentTarget),
      []
    ), P = k(() => {
      e && !i && d(!0);
    }, [e, i, d]);
    return I(() => {
      e || d(!1);
    }, [e, d]), I(() => (e ? n.on() : n.off(), function() {
      e || n.off();
    }), [e]), /* @__PURE__ */ r.createElement(
      "div",
      {
        className: y(`${s.drawer} fuse-drawer`, p),
        ref: l,
        "aria-hidden": e ? void 0 : !0,
        "aria-labelledby": u,
        "aria-modal": e,
        "data-testid": h,
        role: "dialog",
        "data-slide-in": E,
        tabIndex: e && !i ? 0 : -1,
        onBlur: P,
        "data-desktop": z ? "" : void 0,
        "data-scrolled": B ? "" : void 0,
        style: {
          ...C,
          "--drawer-z-index": $,
          "--drawer-height": O
        },
        ...H
      },
      /* @__PURE__ */ r.createElement(
        "div",
        {
          ref: o,
          className: `${s.drawer__contentContainer} fuse-drawer__content`
        },
        /* @__PURE__ */ r.createElement(
          U,
          {
            title: T,
            backCallback: (t) => {
              D(t, l);
            },
            closeCallback: (t) => {
              g(t, l), v();
            },
            drawerHeadingId: u,
            hasBackButton: N,
            srLabelBackButton: S,
            srLabelCloseButton: x
          }
        ),
        /* @__PURE__ */ r.createElement("div", { className: `${s.drawer__body} fuse-drawer__body`, onScroll: R }, f && /* @__PURE__ */ r.createElement(
          "div",
          {
            className: `${s.drawer__promotionalArea} fuse-drawer__body-promotional-area`
          },
          f
        ), c && /* @__PURE__ */ r.createElement("div", { className: `${s.drawer__content} fuse-drawer__body-content` }, c)),
        /* @__PURE__ */ r.createElement(
          M,
          {
            className: y(
              s.drawer__stickyDrawer,
              "fuse-drawer__sticky-drawer",
              a.className
            ),
            dataTestId: a.dataTestId || "fuse-drawer__sticky-drawer",
            open: a.open,
            transition: a.transition,
            zIndex: a.zIndex
          },
          m.button
        )
      )
    );
  }
);
W.displayName = "DrawerDialog";
export {
  W as DrawerDialog
};
